import { render, staticRenderFns } from "./DeleteLearningCenterModal.vue?vue&type=template&id=59df19e4&"
import script from "./DeleteLearningCenterModal.vue?vue&type=script&lang=js&"
export * from "./DeleteLearningCenterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports